import axios from 'axios';
import {
  PickingCart,
  PickedLineStatus,
  GenerateLabelsResponse,
} from '../models/PickingModels';

const API_URL = process.env.REACT_APP_API_URL;

export function searchCartByCode(code: string): Promise<{ data: PickingCart }> {
  return axios.post(`${API_URL}/api/picking-carts/search/`, { code });
}

export function getCartDetail(code: string): Promise<{ data: PickingCart }> {
  return axios.get(`${API_URL}/api/picking-carts/${code}/`);
}

export function toggleLinePicked(
  cartCode: string,
  orderLineId: number
): Promise<{ data: PickedLineStatus }> {
  return axios.post(
    `${API_URL}/api/picking-carts/${cartCode}/mark_line_picked/`,
    {
      order_line_id: orderLineId,
    }
  );
}

export function generateLabels(
  cartCode: string,
  orderId: number,
  nPackages: number
): Promise<{ data: GenerateLabelsResponse }> {
  return axios.post(
    `${API_URL}/api/picking-carts/${cartCode}/generate_labels/`,
    {
      order_id: orderId,
      n_packages: nPackages,
    }
  );
}
